import api from './api';

export interface AcronimoProjeto {
  id: string;
  sigla: string;
  categoriaId: string;
  grupoId: string;
  subGrupoId: string;
  nomeCategoria: string;
  nomeGrupo: string;
  nomeSubGrupo: string;
  // projetos: Projeto[];
}

export const getAllAcronimosProjeto = () => api.get<AcronimoProjeto[]>(`acronimosprojeto`);
export const getAcronimoProjetoById = (id: string) => api.get<AcronimoProjeto>(`acronimosprojeto/${id}`);

export const createAcronimoProjeto = (acronimo: AcronimoProjeto) =>
  api.post<AcronimoProjeto>(`acronimosprojeto`, acronimo);

export const updateAcronimoProjeto = (acronimo: AcronimoProjeto) => {
  return api
    .put<boolean>(`acronimosprojeto/${acronimo.id}`, acronimo)
    .then(result => true)
    .catch(err => false);
};

export const deleteAcronimoProjeto = (id: string) => api.delete(`acronimosprojeto/${id}`);
